export default function fakeApi(target, placeholderText='') {
  const handler = {
    get(target, prop, receiver) {
      if(!target.hasOwnProperty(prop)){
        const fun = function(){
          console.log(`Application "${prop}" called. ${placeholderText}`);
          return undefined;
        };        

        return fun;
      }

      return Reflect.get(...arguments);
    },
  };

  return new Proxy(target, handler);
}